<template>
    <div>
        <Modal
            v-model="show"
            @on-cancel="onCancel"
            draggable
            sticky
            scrollable
            :mask="false"
            :footer-hide="true"
            fullscreen
            :z-index="1022"
            :title="$t('previewPdf')"
        >
            <div class="demo-spin-article">
                <div id="container">
                    <iframe :src="src" v-if="!loading && src"></iframe>
                </div>
            </div>
            <Spin size="large" fix v-if="loading"></Spin>
        </Modal>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: "previewCard",
    props: {
        id_list: { type: Array, default: () => [] },
        side: { type: String, default: "front" },
        type: { type: String, default: "simple" }
    },
    data() {
        return {
            show: true, // open immediately on mount
            loading: false,
            src: ""
        };
    },
    created() {
        this.fetchCard(); // called once on mount since parent uses v-if
    },
    methods: {
        ...mapActions("humanResource/employee", ["printCard"]),
        fetchCard() {
            this.loading = true;
            this.src = "";
            this.printCard({
                employee_id_list: this.id_list,
                side: this.side,
                type: this.type
            })
                .then(response => {
                    this.src = response.url;
                })
                .catch(error => {
                    this.notice({
                        type: "error",
                        text: error?.message || "Failed to load preview."
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onCancel() {
            this.show = false;
            this.src = "";
            this.$emit("cancel");
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "EMPLOYEE PROFILES",
                desc: not.text
            });
        }
    }
};
</script>

<style scoped>
#container {
    width: 100%;
    height: 90vh;
    background: black;
}
#container iframe {
    width: 100%;
    height: 90vh;
    border: none;
}
</style>
